(() => {
    "use strict";

    if (document.getElementById('nav-toggle')) {
        const navToggle = document.getElementById('nav-toggle');
        const navMenu = document.getElementById('nav-menu');

        navToggle.addEventListener('click', e => {
            e.target.classList.toggle('active');
            navMenu.classList.toggle('active');
        });
    }

    if (document.querySelector('[data-toggle]')) {
        const toggles = document.querySelectorAll('[data-toggle]')

        toggles.forEach(toggle => toggle.addEventListener('click', evt => {
            const element = document.querySelector(`[data-target="${evt.target.dataset.toggle}"]`)

            if (evt.target.dataset.toggle.includes('all')) {
                const target = evt.target.dataset.toggle.split('_')

                Array.from(document.querySelectorAll('[data-target]')).filter(el => {
                    if (el.dataset.element.startsWith(target[0])) {
                        el.classList.remove('default-is-active')
                        el.classList.toggle('is-active', !evt.target.classList.contains('is-active'))
                    }
                })
                
                Array.from(document.querySelectorAll('[data-toggle]')).filter(tgl => {
                    if (tgl.dataset.toggle.startsWith(target[0]) && !tgl.dataset.toggle.endsWith('all')) {
                        tgl.classList.remove('default-is-active')
                        tgl.classList.toggle('is-active', !evt.target.classList.contains('is-active'))
                    }
                })

                evt.target.classList.toggle('is-active')

            }

            if (!element) {
                return
            }

            handleVisibility(toggle, element)
        }))

        function handleVisibility(toggle, element) {

            if (toggle.classList.contains('default-is-active')) {
                toggle.classList.remove('default-is-active')
                toggle.classList.toggle('is-active', toggle.dataset.toggle.includes('all'))
            }
            else {
                toggle.classList.toggle('is-active')
            }

            if (element.classList.contains('is-expanded')) {
                element.classList.remove('is-expanded')
            }

            if (element.classList.contains('default-is-active')) {
                element.classList.remove('default-is-active')
                element.classList.toggle('is-active', toggle.dataset.toggle.includes('all'))
            }
            else {
                element.classList.toggle('is-active')
            }
        }
    }

    if (document.getElementById('testimonials')) {
        new Splide('#testimonials', {
            type: 'loop',
            perPage: 3,
            perMove: 1,
            pagination: false,
            arrows: false,
            gap: 32,
            breakpoints: {
                1020: {
                    perPage: 2,
                },
                680: {
                    perPage: 1,
                }
            }
        }).mount()
    }

})()